import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyB_B80amDqUBJwAB41VX_W7FHpwCRgOggU",
  authDomain: "bagrbrno-1.firebaseapp.com",
  projectId: "bagrbrno-1",
  storageBucket: "bagrbrno-1.appspot.com",
  messagingSenderId: "253092484482",
  appId: "1:253092484482:web:83a8516039c823dccdab9b",
  measurementId: "G-HJD3YDFE2H",
};

const app = initializeApp(firebaseConfig);
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LeySfYlAAAAAArXf2JZ3ijmTQNzC_otxlcNKNhV"),
  isTokenAutoRefreshEnabled: true,
});

const analytics = getAnalytics(app);
const functions = getFunctions(app, "europe-west1");

export function logAnalytics(name, additional_params = {}) {
  if (Object.keys(additional_params).length === 0) {
    logEvent(analytics, name);
  } else {
    logEvent(analytics, name, additional_params);
  }
}

export const db = getFirestore(app);
export const handleFormSubmitFunction = httpsCallable(
  functions,
  "handleFormSubmit"
);
